function buildSearchRoutes({ routes, onMountSearchT3, AsyncDomain }) {
  return routes.concat([
    {
      path: 'search(/:searchTerm)(/:searchFilter)',
      props: {
        domain: 'searchT3',
        // Required to prevent a 404 page flashing before searchT3 opens
        component: 'SearchPlaceholder',
        onMount: onMountSearchT3,
      },
      component: AsyncDomain,
    },
  ]);
}

export default {
  buildSearchRoutes,
};
